module.exports = __webpack_public_path__ + "img/qr-placeholder.623cdfb.png";